/**
 * Pixel Meta (Facebook/Instagram) — site public.
 *
 * Trois garde-fous, dans cet ordre :
 *   1. PRODUCTION uniquement (`donoor.org` / `www.donoor.org`) : un `npm run
 *      dev` ou une preview Vercel ne doit jamais polluer les statistiques de
 *      campagne ni déclencher de fausses conversions.
 *   2. CONSENTEMENT marketing obligatoire : sans lui, `fbevents.js` n'est même
 *      pas téléchargé — aucun cookie `_fbp`, aucune requête vers facebook.com.
 *   3. Chargement DIFFÉRÉ (première interaction ou 2,5 s après `load`) : le
 *      script pèse ~157 Ko et 318 ms de CPU mobile. C'est précisément ce coût
 *      qui avait fait retirer le pixel le 2026-08-28 (Quality Score Google Ads
 *      « page inférieure à la moyenne » → clics plus chers).
 *
 * Les changements de choix en cours de visite sont appliqués par `app.vue`
 * (`onConsentUpdate`), qui appelle la même fonction. Toute la mécanique vit
 * dans `@donoor/utils/meta-pixel`, partagée avec le dashboard.
 */
import {
  appliquerConsentementMeta,
  HOTES_META_SITE_PUBLIC,
} from "@donoor/utils/meta-pixel";
import { hasMarketingConsent, readConsent } from "@donoor/utils/consent";

export default defineNuxtPlugin(() => {
  appliquerConsentementMeta({
    hotesAutorises: HOTES_META_SITE_PUBLIC,
    consentementMarketing: hasMarketingConsent(readConsent()),
  });
});
